<app-toast></app-toast>
<div class="h-screen flex flex-col items-center p-5 mobile:p-2">
    <!-- Top bar-->
    <div class="w-full">
        <app-admin-topbar></app-admin-topbar>
    </div>

    <!-- Tab Navigation -->
    <div class="w-full">
        <app-admin-navigation [isActiveNumber]="3"></app-admin-navigation>
    </div>

    <!--Full file data-->
    <div class="w-full h-auto border-[1px] border-border rounded-[20px] flex flex-col mt-2">
        <!-- Header text -->
        <div class="flex">
            <div class="flex flex-col gap-4 h-[60px] justify-between">
                <p class="text-primary font-semibold ml-4 mr-4 mt-4 mobile:text-sm">{{ 'admin.check_file_details'
                    | transloco }}
                </p>
                <div class="h-[2px] w-full bg-primary"></div>
            </div>
            <div class="h-[60px] flex flex-grow items-end justify-start mobile:hidden">
                <div class="h-[2px] w-full bg-border"></div>
            </div>
        </div>

        <!--Content-->
        <div class="w-full flex flex-col gap-2 p-5">
            <div class="w-full flex desktop:flex-wrap gap-2 justify-start items-end mobile:flex-col">
                <!--Choose period-->
                <div class="min-w-[300px] max-w-[600px]">
                    <app-labeled-input labelText="{{ 'admin.file_id' | transloco }}" [inputId]="'fileId'"
                        [inputType]="'text'" [(inputValue)]="fileIdInput" [errorMessage]="fileIdInputError"
                        placeholder="{{ 'admin.file_id_desc' | transloco }}"
                        [isDisabled]="loadingResponse"></app-labeled-input>
                </div>
                <div class="w-[150px] h-[50px] self-end">
                    <app-custom-button buttonText="{{ 'admin.refresh' | transloco }}" [isDisabled]="false"
                        backgroundColor="bg-secondary" textColor="text-black" borderColor="border:bg-secondary"
                        hoverBackgroundColor="hover:bg-secondary-1200" hoverBorderColor="hover:border-secondary-1200"
                        (click)="loadFileSummary()" [isDisabled]="loadingResponse">
                    </app-custom-button>
                </div>
            </div>
            <div class="w-full flex flex-col gap-2" *ngIf="fileDetailsResponse">
                <app-file-details-view [fileDetailsResponse]="fileDetailsResponse"
                    [toast]="toast"></app-file-details-view>
            </div>
        </div>
    </div>
</div>